<template>
  <ui-modal-layout
    :title="tr('Cancel subscription')"
    :description="tr('If you cancel your subscription, you can still use the service during the billing cycle you have already paid for. If you change your mind, you can subscribe to our package that suits you best at any time after cancellation.')"
    :icon="CircleXIcon"
    tone="destructive"
  >
    <template #footer>
      <ui-button variant="destructive" :disabled="isLoading" @click="() => confirm()">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Confirm') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { CircleX, LoaderCircle } from '@lucide/vue';
import { markRaw } from 'vue';

import SubscriptionService from '@/services/Subscription';

export default {
  name: 'CancelSubscriptionModal',
  components: {
    LoaderCircleIcon: LoaderCircle,
  },
  data() {
    return {
      CircleXIcon: markRaw(CircleX),
      isLoading: false,
    };
  },
  methods: {
    confirm() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      SubscriptionService.cancel()
        .then(resp => {
          this.$toast.clear();
          this.$toast.success(this.tr('The subscription has been cancelled.'));
          this.$root.fetchUserData();

          return resp;
        })
        .catch(err => this.error(err))
        .finally(() => this.isLoading = false);
    },
  },
};
</script>

